
import Injection = EECore.Injection;
import { WidgetResources } from "../../resources/widget";
import ContractService from "../../services/corporateSearch/corporateSearchService";
import ClientContractModel from "../../services/entities/corporateSearch/corporateSearchModel";
import ContractItemModel from "../../services/entities/corporateSearch/contractModel";
import ContractItem from "./contractItem";
import Model from "../models/corporateSearch/contractListModel";
import Cookie from "../../../../Core/src/lib/cookie";

@Injection.injectableClass("ContractList")
export default class ContractList implements EECore.UI.IWebComponent {
  @Injection.injectableProperty("ContractList", "WidgetResources")
  private resources: WidgetResources;

  @Injection.injectableProperty("ContractList", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("ContractList", "CorporateSearchService")
  private contractService: ContractService;

  @Injection.injectableProperty("ContractList", EECore.Registrations.WEBCOMPONENT_FACTORY)
  private webComponentFactory: EECore.UI.WebComponentFactory;

  @Injection.injectableProperty("ContractList", EECore.Registrations.DOCUMENT)
  private document: Document;

  @Injection.injectableProperty("ContractList", EECore.Registrations.HTML_HELPER)
  private htmlHelper: EECore.HtmlHelper;

  @Injection.injectableProperty("ContractList", EECore.Registrations.COOKIE)
  private cookie: Cookie;

  constructor(templateFactory: EECore.UI.TemplateFactory, contractService: ContractService, webComponentFactory: EECore.UI.WebComponentFactory, document: Document, resources: WidgetResources, htmlHelper: EECore.HtmlHelper, cookie: Cookie) {
    this.templateFactory = templateFactory;
    this.contractService = contractService;
    this.webComponentFactory = webComponentFactory;
    this.document = document;
    this.resources = resources;
    this.htmlHelper = htmlHelper;
    this.cookie = cookie;
  }

  load(): EECore.Promise<Element, string> {
    const clientNo = this.cookie.getValue("wemwpn45-clientNo");
    const companyCode = this.cookie.getValue("wemwpn45-companyCode");

    if (companyCode === null || clientNo === null) {
      throw new Error("You must specify both companyCode and clientNo in cookies to use the widget.");
    }

    return new EECore.Promise<Element, string>((resolve, reject) => {
      this.contractService.getContracts(clientNo, companyCode).then((clientContract: ClientContractModel) => {
        const template = this.renderTemplate();
        const contractContainer = template.querySelector(".blockHeaderContent");

        this.setupReturnButton(template, clientNo, companyCode);
        contractContainer.appendChild(this.renderItems(clientContract.contracts));

        resolve(template);
      }).catch(() => {
        reject("Could not get the contracts.");
      });
    });
  }

  protected renderTemplate(): Element {
    const model = new Model();
    model.noContractTitle = this.resources.contractList.noContractTitle;
    model.descriptionTitle = this.resources.contractList.descriptionTitle;
    model.returnButton = this.resources.contractList.returnButton;

    return this.templateFactory.getTemplate("ContractList", model);
  }

  protected renderItems(contracts: ContractItemModel[]): Element {
    const documentFragment = this.document.createDocumentFragment() as any;
    for (let i = 0; i < contracts.length; i++) {
      const contractItem = this.webComponentFactory.getWebComponent(ContractItem) as ContractItem;
      contractItem.model = contracts[i];

      const element = contractItem.load();

      if (i % 2 === 1) {
        this.htmlHelper.addCssClass(element, "even");
      }

      documentFragment.appendChild(element);
    }
    return documentFragment;
  }

  private setupReturnButton(contractElement: Element, clientNumber: string, companyCode: string) {
    const element = contractElement.querySelector("#btnReturnClient");
    if (element === undefined || element === null) return;
    element.addEventListener("click", () => {

      location.href = `/WEMWPN45/CorporateSearch/ClientContext?clientNumber=${clientNumber}&companyCode=${companyCode}`;
    });
  }
}